import { State } from 'app/redux';

export const getLanguages = (state: State) => state.languages;
